/**
 * @Author: ikoros
 * @Date:   2020-04-18T23:19:37+08:00
 * @Last modified by:   ikoros
 * @Last modified time: 2020-04-19T01:16:53+08:00
 */

 export const get = () => JSON.parse(sessionStorage.getItem('session')) || {};

 export const set = (session) => {
     sessionStorage.setItem("session", JSON.stringify(session));
 }

 export const remove = () => {
     sessionStorage.removeItem('session');
 }

 const tree = (array) => {
    var treeData = [];
    var treeMaps = {};
    var treeSize = array.length;

    for (let i = 0; i < treeSize; i++) {
        treeMaps[array[i]["id"]] = array[i];
    }

    for (let i = 0; i < treeSize; i++) {
        var node = treeMaps[array[i]["pid"]];
        if (node) {
            if(node.hasOwnProperty('children') === false) {
                node["children"] = [];
            }
            node["children"].push(array[i]);
        } else {
            
            if(array[i].pid === 0) {
                treeData.push(array[i]);
            }
        }
    }

    sortTree(treeData);

    return treeData;
};

